import { render } from "./InvoiceList.vue?vue&type=template&id=3c52669a&scoped=true"
import script from "./InvoiceList.vue?vue&type=script&lang=js"
export * from "./InvoiceList.vue?vue&type=script&lang=js"

import "./InvoiceList.vue?vue&type=style&index=0&id=3c52669a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c52669a"]])

export default __exports__